import React from "react";
import logo from "../../resources/img/Toolbar/logo.svg";
import "./css/toolbar.css";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

const Toolbar = () => {

  const closeMenu = () => {
    const navbar = document.getElementById("navbarNavDropdown");
    const bsCollapse = new window.bootstrap.Collapse(navbar, {
      toggle: false,
    });
    bsCollapse.hide();
  };

  return (
    <nav className="navbar navbar-expand-md navbar-custom fixed-top shadow">
      <div className="container-fluid">
        {/* Logo */}
        <NavLink className="navbar-brand ms-3" to="/" onClick={closeMenu}>
          <img
            src={logo}
            alt="logo"
            width="90"
            height="27"
            className="d-inline-block"
          />
        </NavLink>

        {/* Toggler */}
        <button
          className="navbar-toggler me-3 custom-toggler collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="toggler-icon top-bar"></span>
          <span className="toggler-icon middle-bar"></span>
          <span className="toggler-icon bottom-bar"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse menu-bg-hv" id="navbarNavDropdown">
          <ul className="navbar-nav ms-auto me-4 mb-2 mb-md-0">
            <li className="nav-item me-md-3">
              <NavLink className="nav-link" to="about" onClick={closeMenu}>
                About me
              </NavLink>
            </li>

            <li className="nav-item me-md-3">
              <NavLink className="nav-link" to="books" onClick={closeMenu}>
                Children´s book illustration
              </NavLink>
            </li>

            <li className="nav-item me-md-3">
              <NavLink className="nav-link" to="drawings" onClick={closeMenu}>
                Drawings
              </NavLink>
            </li>

            <li className="nav-item me-md-3">
              <NavLink className="nav-link" to="paintings" onClick={closeMenu}>
                Paintings
              </NavLink>
            </li>

            <li className="nav-item me-md-3">
              <NavLink className="nav-link" to="services" onClick={closeMenu}>
                Services
              </NavLink>
            </li>

            <li className="nav-item">
              <Link className="btn btn-custom w-100 mt-2 mt-md-1" to="contacts" onClick={closeMenu}>
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Toolbar;
